import React, { createRef, RefObject, useEffect, useRef, useState } from 'react';
import { Table, Form, Row, Col, Select, Input, DatePicker, Divider, Button, Typography, InputNumber, Card, Checkbox, notification } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { States, State, Institucion } from 'sigt';
import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import moment from 'moment';
import { DeleteOutlined } from '@ant-design/icons';
import { Utils } from '../../../utils/validators';
import { bankCodes } from '../../../utils/banks';

const MultipleTransactions: React.FC<MultipleTransactionsProps> = ({ banks, selectedInstitution, form, data, maxCred, selectedReqType, maxCredR, auth, files, setFiles, percentTax, mineralTax, credit, bomberos, peajes, isLate, otherTax }) => {
  // BOD, BANESCO Y BNC
  const sedematBanks = [1, 2, 3, 14, 22, 19, 23, 25, 11, 12, 35, 6];
  const recaudosRef = useRef<RefObject<HTMLImageElement>[]>([]);
  const [selectedCode, setSelectedCode] = useState<string>('');

  useEffect(() => {
    if (data.pagos && data.pagos.length > 0) {
      console.log(data)
      console.log(data.pagos[0])
      if (['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data.pagos[0]?.metodoPago)) {
        console.log('set monto')
        if (auth?.user?.tipoUsuario === 4) {
          form.setFieldsValue({
            pagos: data.pagos.map((p) => ({ ...p, 
              costo: data.monto || 0, 
              codigo: selectedCode, 
              // titular: auth?.user?.nombreCompleto,
              // documento: auth?.user?.cedula,
              // tipoDocumento: auth?.user?.nacionalidad,
            })),
          })          
        } else {
          form.setFieldsValue({
            pagos: data.pagos.map((p) => ({ ...p, 
              costo: data.monto || 0, 
              codigo: selectedCode,
            })),
          }) 
        }
      }
    }
  },[data, selectedCode])

  useEffect(()=>{
    if( form.getFieldValue('pagos')?.length > recaudosRef.current?.length ) {
      let diff = form.getFieldValue('pagos')?.length - recaudosRef.current?.length
      for(let i=0; i<diff; i++){
        recaudosRef.current.push(createRef<HTMLImageElement>())    
      }
    }
    else if( form.getFieldValue('pagos')?.length < recaudosRef.current?.length ) {
      let diff = recaudosRef.current?.length - form.getFieldValue('pagos')?.length 
      for(let i=0; i<diff; i++){
        recaudosRef.current.splice(-1,1);  
      }
    }
  },[form]);

  const handleFiles = (e, name: string, i: number) => {
    const file = e.target.files[0];
    if (file) {
      const fr = new FileReader();
      const blob = (file as File).slice(0, (file as File).size, file.type);
      setFiles({
        ...files,
        [name]: new File([blob], `${name}.${file.name.split('.')[file.name.split('.').length - 1]}`, { type: file.type }),
      });
      fr.readAsDataURL(file);
      fr.onload = (e) => {
        if (file.type.includes('image')) recaudosRef.current[i]?.current?.setAttribute('src', e.target?.result?.toString() || '');
        else if (file.type.includes('excel')) {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/excel.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        } else if (file.type.includes('pdf')) {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/pdf.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        } else {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/file.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        }
      };
    }
  };

  const deleteFile = (name: string, i: number) => {
    const _files = Object.assign({}, files);
    delete _files[name];
    setFiles(_files);
    recaudosRef.current[i] = createRef();
  };

  const docTypeSelect = (field) => ( 
    <Form.Item noStyle name={[field.name, 'tipoDocumento']} rules={[{ required: true, message: 'Debe ingresar el tipo de documento del contribuyente' }]} >
      <Select>
        <Select.Option value='J'>J</Select.Option>
        <Select.Option value='G'>G</Select.Option>
        <Select.Option value='V'>V</Select.Option>
        <Select.Option value='E'>E</Select.Option>
        <Select.Option value='P'>P</Select.Option>
      </Select>
    </Form.Item>
  );

  const prefixSelect = (field) => (
    <Form.Item noStyle name={[field.name, 'prefijo']} >
      <Select>
        <Select.Option value='0424'>0424</Select.Option>
        <Select.Option value='0414'>0414</Select.Option>
        <Select.Option value='0412'>0412</Select.Option>
        <Select.Option value='0426'>0426</Select.Option>
        <Select.Option value='0416'>0416</Select.Option>
        <Select.Option value='0422'>0422</Select.Option>
      </Select>
    </Form.Item>
  );

  const bankColumns: ColumnsType<any> = [
    {
      title: 'Banco',
      dataIndex: 'banco',
      key: 'banco',
      fixed: 'left'
    },
    {
      title: 'Numero de Cuenta',
      dataIndex: 'numeroCuenta',
      key: 'numeroCuenta'
    },
    {
      title: 'Titular',
      dataIndex: 'nombreTitular',
      key: 'nombreTitular'
    },
    {
      title: 'Documento de Identidad',
      dataIndex: 'documento',
      key: 'documento',
    }
  ];

  const firstListItem = (fields, add) => {
    if(fields.length === 0 && ((!credit || credit?.length === 0) && isLate)) {
      // setTimeout(() => add(), 50);
      add();
    }
  };

  const alreadyUsedCredit = () => data.pagos && data.pagos.find(p => p && p.metodoPago === 'CREDITO_FISCAL');
  const alreadyUsedCreditR = () => data.pagos && data.pagos.find(p => p && p.metodoPago === 'CREDITO_FISCAL_RETENCION');

  return ( 
    <React.Fragment>
      <Table bordered pagination={false} style={{ marginBottom: 15 }} columns={bankColumns} dataSource={
        selectedInstitution?.cuentasBancarias?.filter((c) => !(Number(c.id) === 6 || Number(c.id) === 7)).filter(
          (b) => mineralTax ? b.usoRamo?.includes('Minerales') : ( percentTax ? b.usoRamo?.includes('2x100') && (Number(b.id) !== 1 && Number(b.id) !== 2) : ( bomberos ? b.usoRamo?.includes('Bomberos') : ( peajes ? b.usoRamo?.includes('Peajes') : (b.usoRamo?.includes('Timbres') || (otherTax ? b.usoRamo?.includes('Otros') : false)) && (Number(b.id) !== 4 && Number(b.id) !== 5))))
          ).filter((c) => !(c.metodoPago?.length === 1 && c.metodoPago[0] === 'PUNTO')).map((c) => 
        ({numeroCuenta: c.numeroCuenta, 
        documento: `${(c.rif) ? 'RIF: ' : 'Cedula: '}${(c.rif || c.cedula)}`, nombreTitular: c.nombreTitular, banco: banks?.find(b => b.id === c.banco)?.nombre, key: c.id })
      )} />
      <Form.List name='pagos'>
        {(fields, { add, remove }) => (
          <div>
            {firstListItem(fields, add)}
            {fields.map((field, index) => { 
              const ref = React.createRef<HTMLInputElement>();
              return (
              <React.Fragment key={field.key}>
                <Divider style={{ margin: 5, marginLeft: -5 }} orientation='left'>
                  <Typography.Text strong style={{ marginLeft: 5 }}>
                    Transacción {index + 1}
                  </Typography.Text>
                </Divider>
                <Form.Item required key={field.key} style={{ width: '100%', margin: 0 }}>
                  <Row gutter={24} style={{ padding: '0 20px' }}>
                    <Col xl={8} xs={24}>
                      <Form.Item label='Método de Pago' name={[field.name, 'metodoPago']} rules={[{ required: true, message: 'Debe indicar el método de pago' }]}>
                        <Select placeholder='Método de Pago' onChange={(v) => {
                          if(['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(String(v))) {
                          let pagos = data.pagos
                          pagos[field.key] = { ...pagos[field.key], costo: data.monto || 0, metodoPago: v };
                          form.setFieldsValue({pagos: pagos});
                          }
                        }}>
                          <Select.Option value='TRANSFERENCIA'>Transferencia</Select.Option>
                          { auth?.user?.tipoUsuario !== 4 && <Select.Option value='PUNTO DE VENTA'>Punto de Venta</Select.Option>}
                          <Select.Option value='DEPOSITO'>Depósito</Select.Option>
                          {/* <Select.Option value='COBRAYA'>Pago Móvil C2P</Select.Option> */}
                          {(auth?.user?.tipoUsuario === 4 || auth?.user?.id === 92727) && <Select.Option value='PAGOMOVILBNC'>Reportar Pago Móvil o Transferencia BNC</Select.Option>}
                          {(auth?.user?.tipoUsuario === 4 || auth?.user?.id === 92727) && <Select.Option value='VPOSBNC'>Punto Virtual BNC</Select.Option>}
                          {(auth?.user?.tipoUsuario === 4 || auth?.user?.id === 92727) && <Select.Option value='C2PBNC'>Pago Móvil C2P</Select.Option>}
                          {/* {(selectedReqType !== 'RETENCION' && maxCred && maxCred > 0)  && <Select.Option disabled={alreadyUsedCredit()} value='CREDITO_FISCAL'>Credito Fiscal por compesanción</Select.Option>}
                          {(selectedReqType !== 'RETENCION' && maxCredR && maxCredR > 0)  && <Select.Option disabled={alreadyUsedCreditR()} value='CREDITO_FISCAL_RETENCION'>Credito Fiscal por retención</Select.Option>} */}
                        </Select>
                      </Form.Item>
                    </Col>
                    {data.pagos && (data.pagos[field.name]?.metodoPago !== 'EFECTIVO' && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' ) && 
                    <Col xs={24} xl={8}>
                      <Form.Item label='Banco de Origen' name={[field.name, 'banco']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Debe indicar el banco' }]}>
                        {banks ? 
                        <Select placeholder='Banco de Origen' onChange={(v) => {
                          if(data.pagos[field.name]?.metodoPago === 'COBRAYA')       
                            notification.info({
                              placement:'topLeft',
                              bottom: 50,
                              duration: 0,
                              style:{color:'black', border:'4px black solid', 
                              // backgroundColor:'#fafafa' 
                            },
                              message:`Como obtener clave C2P para ${banks.find((b) => b.id === v)?.nombre}`,
                              description:bankCodes.find((el) => el.id === v)?.text || 'Seleccione Banco de Origen'
                            });
                            setSelectedCode(bankCodes.find((el) => el.id === v)?.codigo || '');
                            }}>
                          {banks?.filter((b) => ['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) ? bankCodes.find((c) => c.id === b.id) : true)?.map((b, i) =>
                            <Select.Option key={`b-${b.id}`} value={b.id}>{b.nombre}</Select.Option>
                          )}
                          {/* <Select.Option value={11}>Banco de Venezuela S.A.C.A. Banco Universal</Select.Option> */}
                        </Select> : <div></div>}
                      </Form.Item>
                    </Col>}
                    {data.pagos && (data.pagos[field.name]?.metodoPago !== 'EFECTIVO' && !['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' ) && 
                    <Col xs={24} xl={8}>
                      <Form.Item label='Banco de Destino' name={[field.name, 'destino']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Debe indicar el banco' }]}>
                        {banks ? 
                        <Select placeholder='Banco de Destino'>
                          {
                            selectedInstitution?.cuentasBancarias?.filter(
                              (b) => mineralTax ? b.usoRamo?.includes('Minerales') : ( percentTax ? b.usoRamo?.includes('2x100') : ( bomberos ? b.usoRamo?.includes('Bomberos') : (peajes ? b.usoRamo?.includes('Peajes') : (b.usoRamo?.includes('Timbres') ||  (data.ramo === 516 && Number(b.id) === 8))) || (otherTax ? b.usoRamo?.includes('Otros') : false) ))
                              ).filter((b) => b.metodoPago?.includes(data.pagos[field.name]?.metodoPago === 'PUNTO DE VENTA' ? 'PUNTO' : (data.pagos[field.name]?.metodoPago === 'COBRAYA' ? 'TRANSFERENCIA' : data.pagos[field.name]?.metodoPago))).map((b, i) =>
                              <Select.Option key={`b-${b.id}`} value={b.id}>{ b.numeroCuenta?.slice(b.numeroCuenta?.length - 4) + ' - ' + banks.find((bank) => bank.id === b.banco)?.nombre}</Select.Option>
                            )
                          }
                        </Select> : <div></div>}
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Tipo de Cuenta' rules={[{ required: true, message: 'Por favor seleccione el tipo de cuenta' }]} name={[field.name, 'tipoCuenta']}>
                        <Select placeholder="Tipo de Cuenta">
                          <Select.Option value='00'>Principal</Select.Option>
                          <Select.Option value='10'>Ahorro</Select.Option>
                          <Select.Option value='20'>Corriente</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['COBRAYA','VPOSBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Documento' rules={[{ required: true, message: 'Por favor ingresar el documento del titular'}]} name={[field.name, 'documento']}>
                        <Input addonBefore={docTypeSelect(field)} placeholder="Documento" maxLength={9} />
                      </Form.Item>
                    </Col>}
                    {/* {data.pagos && ['PAGOMOVILBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Nro de Cuenta' rules={[{ required: true, message: 'Por favor ingrese el número de cuenta' }]} name={[field.name, 'cuenta']}>
                        <Input placeholder="Titular" maxLength={50}/>
                      </Form.Item>
                    </Col>}            */}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Nombre del Titular' rules={[{ required: true, message: 'Por favor ingrese el nombre del titular' }]} name={[field.name, 'titular']}>
                        <Input placeholder="Titular" maxLength={50} />
                      </Form.Item>
                    </Col>} 
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Número de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el número de tarjeta' }]} name={[field.name, 'tarjeta']}>
                        <Input placeholder="Tarjeta" maxLength={20} minLength={20}/>
                      </Form.Item>
                    </Col>}   
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Pin de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el pin de la tarjeta' }]} name={[field.name, 'pin']}>
                        <Input placeholder="Pin" maxLength={6} minLength={4}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='CVV de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el CVV de la tarjeta' }]} name={[field.name, 'cvv']}>
                        <Input placeholder="CVV" maxLength={3} minLength={3}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Mes Exp. de Tarjeta' rules={[{ required: true, message: 'Por favor seleccione el mes de expiración de la tarjeta' }]} name={[field.name, 'mesEx']}>
                        <Select placeholder="Mes">
                          {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                            <Select.Option key={m} value={m}>{m < 10 ? `0${m}` : `${m}`}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>} 
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Año Exp. de Tarjeta' rules={[{ required: true, message: 'Por favor ingrese el año de expiración de la tarjeta' }]} name={[field.name, 'anioEx']}>
                        <Input placeholder="Año" maxLength={4} minLength={4}/>
                      </Form.Item>
                    </Col>}
                    {data.pagos && ['VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Tipo de Tarjeta' rules={[{ required: true, message: 'Por favor seleccione el tipo de tarjeta' }]} name={[field.name, 'tipoTarjeta']}>
                        <Select placeholder="Tipo de Tarjeta">
                          {/* <Select.Option value='1'>VISA</Select.Option>
                          <Select.Option value='2'>MasterCard</Select.Option> */}
                          <Select.Option value='3'>Débito Maestro</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>}           
                    {data.pagos && ['COBRAYA','PAGOMOVILBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='Teléfono' rules={[{ required: true, message: 'Por favor ingrese el teléfono del titular' }]} name={[field.name, 'telefono']}>
                        <Input addonBefore={prefixSelect(field)} placeholder="Teléfono" maxLength={7} minLength={7}/>
                      </Form.Item>
                    </Col>} 
                    {data.pagos && (data.pagos[field.name]?.metodoPago !== 'EFECTIVO' && !['COBRAYA', 'VPOSBNC', 'C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL' && data.pagos[field.name]?.metodoPago !== 'CREDITO_FISCAL_RETENCION' ) && 
                    <Col xs={24} xl={8}>
                      <Form.Item label='Numero de Referencia' name={[field.name, 'referencia']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Por favor ingrese el numero de referencia.', whitespace:true}]}>
                        <Input placeholder='Referencia' maxLength={20} />
                      </Form.Item>
                    </Col>}
                    { data.pagos && !['COBRAYA', 'VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) &&
                    <Col xs={24} xl={8}>
                      <Form.Item label='Fecha de Pago' name={[field.name, 'fecha']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Por favor ingrese la fecha de pago.' }]}>
                        <DatePicker style={{ width: '100%' }} format={"DD-MM-YYYY"} disabledDate={(current) => current > moment().endOf('day')} />
                      </Form.Item>
                    </Col> }
                    <Col xs={24} xl={8}>
                      <Form.Item label='Monto' name={[field.name, 'costo']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Por favor ingrese el monto del pago.' }]}>
                        <InputNumber max={data.pagos && data.pagos[field.name]?.metodoPago === 'CREDITO_FISCAL' ? maxCred : data.pagos && data.pagos[field.name]?.metodoPago === 'CREDITO_FISCAL_RETENCION' ? maxCredR : undefined} 
                          value={data.pagos[field.name]?.costo}
                          // disabled={['COBRAYA','PAGOMOVILBNC','VPOSBNC'].includes(data.pagos[field.name]?.metodoPago) && data.pagos[field.name]?.costo === data.monto}
                          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 
                          parser={value => value ? value.replace(/Bs\s?|(,*)/g, '') : ''} min={0} step={1} style={{ width: '100%' }} placeholder='Monto' />
                      </Form.Item>
                      {files && files.hasOwnProperty(`Comprobante${index+1}`) ? ( 
                       data.pagos[field.name]?.metodoPago !== 'COBRAYA' &&
                      <Col xs={24} xl={6} key={index}>
                      <Card
                        cover={<img alt='recaudo' ref={recaudosRef.current[index]} />}
                        bodyStyle={{ padding: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                      >
                        <Typography.Text strong style={{ textAlign: 'center' }}>
                          {`Comprobante${index+1}`}
                        </Typography.Text>
                        <Button
                          type='link'
                          onClick={() => deleteFile(`Comprobante${index+1}`, index)}
                          style={{ textAlign: 'right', width: '100%', color: 'red' }}
                        >
                          Eliminar
                          <DeleteOutlined />
                        </Button>
                      </Card>
                    </Col>
                    ) : (
                      !['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) &&
                    <Col xs={24} xl={6}>
                      <input
                      hidden
                      ref={ref}
                      type='file'
                      onChange={(e) => handleFiles(e,`Comprobante${index+1}` ,index)}
                    />
                    <Button type='primary' style={{ marginTop: 10, marginBottom: 10}} onClick={() => ref.current?.click()}>
                      Cargar comprobante
                    </Button>  
                    </Col> 
                    )}                   
                  </Col>
                  {data.pagos && ['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xl={8} xs={24}>
                      <Form.Item label='' name={[field.name, 'codigo']} rules={[{ required: true }]}>
                        <Input hidden value={selectedCode}/>
                      </Form.Item>
                    </Col>} 
                  {data.pagos && ['COBRAYA','C2PBNC'].includes(data.pagos[field.name]?.metodoPago) && 
                    <Col xs={24} xl={8}>
                      {/* <Typography.Paragraph>{bankCodes.find((el) => el.id === selectedInstitution?.cuentasBancarias?.find((c) => c.id === data.pagos[field.name]?.destino)?.banco)?.text || 'Seleccione Banco de Destino'}</Typography.Paragraph> */}
                      <Form.Item label='Código C2P' name={[field.name, 'tokenc2p']} fieldKey={field.fieldKey} rules={[{ required: true, message: 'Por favor ingrese el código C2P' }]}>
                        <Input placeholder='Ingrese código C2P' maxLength={8} minLength={4} />
                      </Form.Item>
                    </Col>}
                  </Row>
                </Form.Item>
              </React.Fragment>
            )})}
            { (( data.pagos && !['COBRAYA','PAGOMOVILBNC','VPOSBNC','C2PBNC'].includes(data?.pagos[0]?.metodoPago)) || (!data.pagos)) &&
            <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {((fields.length > 0 && !isLate) || (fields.length > 1 && isLate) || (credit && credit?.length > 0)) &&
              <Col>
                <Button type='danger' onClick={() => remove(fields.length - 1)}>Eliminar Transacción</Button>
              </Col>}
              <Col>
                <Button type='dashed' onClick={() => add()}>Agregar Transacción</Button>
              </Col>
            </Row>}
          </div>
        )}
      </Form.List>
    </React.Fragment>
  );
};

const mapStateToProps = (state: State) => ({ banks: state.bk.banks, auth: state.auth });

export default connect(mapStateToProps)(MultipleTransactions);

interface MultipleTransactionsProps {
  banks: States.Banks['banks']
  selectedInstitution?: Institucion
  form: FormInstance
  data: any
  maxCred?: number
  maxCredR?: number
  selectedReqType?: string
  auth: States.Auth
  files?: any
  setFiles?: any
  percentTax?: boolean
  mineralTax?: boolean
  credit?: any
  bomberos?: boolean
  peajes?: boolean
  isLate?: boolean
  otherTax?: boolean
}